import { Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { type ActionItemProps } from './actionRegistry';
import { StatusIndicator } from './StatusIndicator';
import { getItemStyles } from './itemStyles';
import excelIcon from '@/assets/images/excel.png';
import { AlertCircle } from '@kula-ai/icons-core';

/**
 * Export CSV action component
 * Shows excel icon and export progress
 */
export const ExportCsv = ({ item }: ActionItemProps) => {
  const styles = getItemStyles(item.status);

  const isFailed = item.status === 'failed';

  return (
    <Flex
      py="12px"
      px="20px"
      alignItems="center"
      justifyContent="space-between"
      borderBottom="1px solid"
      bg={styles.container.bg}
      borderColor={styles.borderColor}
      _first={{ borderTop: '1px solid', borderColor: styles.borderColor }}
      _last={{
        borderBottom: isFailed ? '1px solid' : 'none',
        borderColor: styles.borderColor,
      }}
    >
      <Flex alignItems="center" gap="10px" flex={1} minW={0}>
        <img src={excelIcon} alt="CSV" width={20} height={20} />
        <KText
          size="sm"
          noOfLines={1}
          flex={1}
          enableTooltip
          tooltipText={item.name}
          color={styles.text.color}
        >
          {item.name}
        </KText>
      </Flex>

      <Flex alignItems="center" flexShrink={0}>
        {isFailed && item.errorType ? (
          <Flex
            alignItems="center"
            gap="6px"
            bg="error-600"
            borderRadius="100px"
            px="10px"
            py="4px"
          >
            <AlertCircle
              size={14}
              color="var(--kula-colors-white)"
              className="kula-icon"
            />
            <KText size="xs" color="static-white">
              {item.errorType}
            </KText>
          </Flex>
        ) : isFailed ? (
          <StatusIndicator status={item.status} progress={item.progress} />
        ) : (
          <StatusIndicator
            status={item.status}
            progress={item.progress}
            errorType={item.errorType}
          />
        )}
      </Flex>
    </Flex>
  );
};
